import { customFetch as fetch } from './fetch';

export class PostalCodeSearchResult {
    public success: boolean;
    public street: string;
    public town: string;
};

export async function lookupAddress(
    postalCode: string,
    houseNumber: string
): Promise<PostalCodeSearchResult> {
    const fd = new FormData();
    fd.append('postalCode', postalCode);
    fd.append('houseNumber', houseNumber);

    const response = await fetch('/Api/PostalCode/LookupPostalCode', {
        method: 'post',
        body: fd
    });

    return <PostalCodeSearchResult>response.data;
}